<template>
  <div class="lg:h-full lg:border flex flex-col lg:flex-row">
    <div class="w-full lg:w-1/4 border lg:border-0 lg:border-r p-6">
      <div class="flex flex-col items-center gap-2 mb-4">
        <img
          class="rounded-full"
          v-if="userData.profilePicture"
          width="100"
          :src="`${backendUrl}${userData.profilePicture}`
          "
          alt="User's Profile Picture"
        />
        <avatar
          v-else
          :size="100"
          :username="username"
        ></avatar>
        <h5 class="title">
          {{ username }}
        </h5>
      </div>
      <AccountMenu
        :menus="menus"
        :menuActive="menuActive"
        @menu-change="menuChange"
      />
    </div>
    <div
      class="w-full lg:w-3/4 border lg:border-0 mt-6 lg:mt-0 p-6 lg:overflow-y-auto"
    >
      <h3 class="pb-2">{{ headerMenu.name }}</h3>
      <p>{{ headerMenu.description }}</p>
      <div class="mt-10" v-if="'firstName' in userData">
        <template v-if="menuActive === 1">
          <profil :userProfile="userData" @fetchUserData="fetchUserData" />
        </template>
        <template v-if="menuActive === 2">
          <pengaturan-akun
            :userAccount="userData"
            @account-change="handleAccountChange"
            @verify-email="handleVerifyEmail"
          />
        </template>
        <template v-if="menuActive === 3">
          <riwayat-pembelian />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
const AccountMenu = () => import('@/components/App/Menus/Account')
const Profil = () => import('@/views/Akun/Profil')
const PengaturanAkun = () => import('@/views/Akun/PengaturanAkun')
const RiwayatPembelian = () => import('@/views/Akun/RiwayatPembelian')

const menus = [
  {
    key: 1,
    id: 'profil',
    name: 'Profil',
    description: 'Tambahkan informasi tentang diri Anda',
  },
  {
    key: 2,
    id: 'pengaturan-akun',
    name: 'Pengaturan Akun',
    description: 'Ubah pengaturan akun dan ubah sandi Anda di sini',
  },
  {
    key: 3,
    id: 'riwayat-pembelian',
    name: 'Riwayat Pembelian',
    description: 'Informasi seputar daftar riwayat pembelian kelas',
  },
]
export default {
  components: {
    AccountMenu,
    Profil,
    PengaturanAkun,
    RiwayatPembelian,
    Avatar,
  },
  data() {
    return {
      menus,
      menuActive: 1,
      userData: {},
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  methods: {
    fetchUserData() {
      this.$store.dispatch('user/FETCH_USER_DATA')
        .then(res => {
          // console.log('fetchUserData res =>', res)
          const data = res.data
          this.userData = { ...this.userData, ...data }
        })
        .catch(err => {
          console.log('fetchUserData err =>', err)
        })
    },
    menuChange(value) {
      this.menuActive = value
      this.$router.push({ name: 'Akun', query: { menu: this.headerMenu.id } })
    },
    handleVerifyEmail() {
      this.$store.dispatch('user/VERIFY_EMAIL_REQUEST')
        .then(res => {
          if (res.status) {
            this.notification.success({
              title: 'Sukses',
              message: 'Berhasil Mengirim Verifikasi, Mohon Cek Inbox Email Anda!',
              duration: 3000,
            })
          } else {
            this.notification.error({
              title: 'Error',
              message: 'Gagal Mengirim Verifikasi',
              duration: 3000,
            })
          }
        })
        .catch(err => {
          console.log('handleVerifyEmail err =>', err)
          this.notification.error({
            title: 'Error',
            message: err,
            duration: 3000,
          })
        })
    },
    handleAccountChange(payload) {
      console.log('handleAccountChange', payload)
      this.$store.dispatch('user/UPDATE_USER_ACCOUNT', { payload })
        .then(res => {
          console.log(res)
          if (res.isSuccess && payload.newEmail) {
            this.notification.success({
              title: 'Sukses',
              message: 'Berhasil Memperbaharui Akun User, Mohon Cek Inbox Email Anda Untuk Verifikasi!',
              duration: 3000,
            })
          } else if (res.isSuccess) {
            this.notification.success({
              title: 'Sukses',
              message: 'Berhasil Memperbaharui Akun User',
              duration: 3000,
            })
          } else {
            this.notification.error({
              title: 'Error',
              message: 'Gagal Memperbaharui Akun User',
              duration: 3000,
            })
          }
        })
        .catch(err => {
          console.log('handleAccountChange err =>', err)
          this.notification.error({
            title: 'Error',
            message: err,
            duration: 3000,
          })
        })
    },
  },
  mounted() {
    this.fetchUserData()
    if (this.$route.query.menu) {
      this.menuActive = this.menus.find(el => el.id === this.$route.query.menu).key
    } else {
      this.menuActive = 1
    }
  },
  computed: {
    headerMenu() {
      return this.menus.find(el => el.key === this.menuActive)
    },
    username() {
      return this.userData?.firstName && this.userData?.lastName ? this.userData.firstName + ' ' + this.userData.lastName : '-'
    },
  },
}
</script>

<style lang="scss">
.account-container {
  height: 100%;
  display: flex;
  flex-direction: column;

  .left {
    padding: 30px 25px;
    border-right: 1px solid var(--kit-border);

    .profile {
      text-align: center;
      margin-bottom: 30px;
      img {
        margin-bottom: 8px;
      }
    }
  }

  .right {
    padding: 30px 25px;
    overflow-y: auto;
    .subheading {
      padding-top: 4px;
    }
  }

  @media (min-width: 800px) {
    & {
      flex-direction: row;

      .left {
        width: 25%;
      }

      .right {
        width: 75%;
        .content {
          margin-top: 40px;
        }
      }
    }
  }
}
</style>
